var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element)?_c('div',{staticClass:"animated fadeIn"},[_c('pdf',{attrs:{"src":((_vm.axios.defaults.baseURL) + "media_files/" + (_vm.element.file.id))}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }